import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { ResponsiveService } from './responsive.service';

@Injectable({
    providedIn: 'root'
})
export class SnackService {
    snackBarRef: MatSnackBarRef<SimpleSnackBar>;
    constructor(
        private snackBar: MatSnackBar,
        private responsiveService: ResponsiveService
    ) { }

    public config(panelClasses: string) {
        const config = new MatSnackBarConfig();
        config.panelClass = [panelClasses];
        this.responsiveService.isScreenSmall() ? config.verticalPosition = 'bottom' : config.verticalPosition = 'top';
        return config;
    }


    /** the snackbar opened last by `open` / `openAfterCurrent`, null once it is dismissed */
    private currentRef: MatSnackBarRef<SimpleSnackBar> | null = null;

    open(message: string, config?: MatSnackBarConfig<any>, action?: string, verticalPositionBigScreen?: "top" | "bottom", durationMs = 6000): MatSnackBarRef<SimpleSnackBar> {
        if (config) {
            config.duration = durationMs;
            this.responsiveService.isScreenSmall() ? config.verticalPosition = 'bottom' : config.verticalPosition = 'top';
            if (verticalPositionBigScreen) config.verticalPosition = verticalPositionBigScreen
        }
        const ref = this.snackBar.open(message, action ? action : 'Ok', config ? config : { duration: 8000 });
        this.currentRef = ref;
        ref.afterDismissed().subscribe(() => { if (this.currentRef === ref) this.currentRef = null; });
        return ref;
    }

    /**
     * Opens the snackbar after the one currently shown is dismissed (MatSnackBar shows one at a time - a plain
     * `open` would replace it at once); right away when none is shown. For a follow-up that must not swallow the
     * preceding message, e.g. the "new account created" hint after the login snackbar (code auth P3, E3).
     */
    openAfterCurrent(message: string, config: MatSnackBarConfig<any>, durationMs: number) {
        const current = this.currentRef;
        if (!current) {
            this.open(message, config, null, undefined, durationMs);
            return;
        }
        current.afterDismissed().subscribe(() => this.open(message, config, null, undefined, durationMs));
    }
    openOfflineMessage(message) {
        const config = this.config('warning');
        this.snackBarRef = this.snackBar.open(message, '', config);
    }

    closeOfflineMessage() {
        console.log('closeOfflineMessage');
        if (this.snackBarRef) {
            console.log('this.snackBarRef');
            this.snackBarRef.dismiss();
        }
    }
    dismiss() {
        this.snackBar.dismiss();
    }

}
